import React from 'react';

interface CrownIconProps {
  className?: string;
  size?: number;
}

export function CrownIcon({ className = 'text-black', size = 16 }: CrownIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 16L3 8L7 10L12 4L17 10L21 8L19 16H5Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 16H19V18H5V16Z" fill="currentColor" />
      <circle cx="7" cy="20" r="1" fill="currentColor" />
      <circle cx="12" cy="20" r="1" fill="currentColor" />
      <circle cx="17" cy="20" r="1" fill="currentColor" />
    </svg>
  );
}
